<template>
<div class="login-form">
    <div class="form border ">
        <h1>{{$lang('TITLE_CHANGE_PASSWORD')}}</h1>
        <b-form @submit="onSubmit">
            <b-form-group class="pass_word">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="changeForm.password" ref="password" type="password" name="password" :placeholder="$lang('FIELD_PASSWORD')" :class="errors.has('password') && 'is-invalid' " v-validate="'required|password'"></b-form-input>
                <div class="help-block"><span class="text-primary">{{$lang('PWD_MUST_OVER_8')}}</span></div>
                <b-form-invalid-feedback :state="errors.has('password')">
                    {{errors.first('password')}}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="pass_word">
                <template slot="label">
                    <label></label>
                </template>
                <b-form-input v-model="changeForm.repassword" data-vv-as="password" type="password" name="repassword" :placeholder="$lang('FIELD_PASSWORD_AGAIN')" :class="errors.has('repassword') && 'is-invalid' " v-validate="'required|confirmed:password'"></b-form-input>
                <div class="help-block"><span class="text-primary">{{$lang('PWD_MUST_OVER_8')}}</span></div>
                <b-form-invalid-feedback :state="errors.has('repassword')">
                    {{errors.first('repassword')}}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-button type="submit" class="register" variant="primary">{{$lang('BTN_YES')}}</b-button>
        </b-form>
    </div>
</div>
</template>

<script>
import LaddaBtn from '@/components/ladda/Ladda';
export default {
    data() {
        return {
            changeForm: {
                password: null,
                repassword: null,
            },
            hash: this.$route.params.hash,
            locale: this.$route.params.locale
        }
    },
    components: {
        LaddaBtn
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            let params = {
                password: this.changeForm.password,
                hash: this.hash
            }
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$apis.user.changePassword(params).then((resp) => {
                        this.notification.success(this.$lang('修改密碼成功'))
                        this.$router.push({
                            name: 'home'
                        })
                    }).catch(err => {
                        this.$router.push({
                            name: 'home'
                        })
                    })
                } else {
                    return false
                }
            })
        },
        checkHashCode(hash, _locale) {
            this.$apis.checkHashCode({
                hash,
                _locale
            }).then(resp => {

            }).catch(err => {
                console.log(hash, _locale);
                this.$router.push({
                    path: '/' + _locale + '/'
                })
            })
        }
    },
    created() {
        this.checkHashCode(this.hash, this.locale);
    }
}
</script>
